import Grid from "@mui/material/Unstable_Grid2";
import CustomAutocomplete from "../../../components/ui/CustomAutocomplete";
import React, {useEffect, useRef, useState} from "react";
import axiosInstance from "../../../components/util/AxiosUtil";
import {useForm} from "react-hook-form";
import {Button} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ConstructionIcon from '@mui/icons-material/Construction';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import IncidentDiagramsBtn from '../IncidentDiagramsBtn';
import IncidentDtlModal from '../IncidentDtlModal';
import Alert from '../../../components/ui/Alert'
import IncidentMultiModal from "../IncidentMultiModal";

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useTheme } from '@mui/material/styles';

const defaultValues = {
    pjtSeq: '',                 /* 프로젝트 일련번호 */
    sido : '',                  /* 시도 */
    sigungu : '',               /* 군구 */
    nrnGentCd : '',             /* 에너지원코드 */
    siteSeq : '',               /* 사이트 일련번호 */
    oosTypeCd : '',             /* 장애 유형 코드 oosTypeCd */
}

/* 멀티 셀렉트 옵션 */
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 230,
    },
  },
};
function getStyles(value, selectedList, theme) {
  return {
    fontWeight: selectedList.includes(value)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

//검색창
const IncidentStsSearch = ({search, checkList}) => {

    // [검색] 조회 기본세팅 - useForm
    const {
        handleSubmit : handleSubmit,
        getValues: getValues,
        control : control,
        setValue : setValue,
        formState: { errors }
    } = useForm( {defaultValues} );

    // Alert ref 객체
    const alertRef= useRef();

    // 프로젝트 목록
    const [pjtList, setPjtList] = useState([{dtlCd: "", dtlCdNm: ""}]);
    //에너지원 목록
    const [enrgList, setEnrgList] = useState([{dtlCd: "", dtlCdNm: ""}]);
    const [selectedNrnCdList, setSelectedNrnCdList] = useState([]);
    // 사이트 목록
    const [siteList, setSiteList] = useState([{dtlCd: "", dtlCdNm: "전체"}]);
    //장애유형 목록 (multiSelect)
    const [oosTypeCdList, setOosTypeCdList] = useState([{dtlCd: "", dtlCdNm: "전체"}]);
    const [selectedOosTpCdList, setSelectedOosTpCdList] = useState([]);

    //조치자&출장파견자 목록
    const [usrBtrList, setUsrBtrList] = useState([{btrrId: "", btrrNm: ""}]);
    //조치결과 목록
    const [actnRsltList, setActnRsltList] = useState({dtlCd: "", dtlCdNm: ""})

    //시도 목록 조회 (multiSelect)
    const [sidoList, setSidoList] = useState([{sido: "", incCnt:0, active: false}]);
    const [selectedSidoList, setSelectedSidoList] = useState([]);

    //구군 목록 조회 (multiSelect)
    const [sigunguList, setSigunguList] = useState([{sido: "", sigungu: "", incCnt:0, active: false}]);
    const [selectedSigunguList, setSelectedSigunguList] = useState([]);

    //출장등록,조치등록 모달 오픈
    const [open, setOpen] = useState(false);
    //출장등록, 조치등록 멀티 모달 오픈
    const [multiOpen, setMultiOpen] = useState(false);
    //조치등록,출장등록 버튼 구분
    const [btnType, setBtnType] = useState('');

    /* 멀티 셀렉트 옵션 */
    const theme = useTheme();
    const sidoMultiChange = (event) => {
        const { target: { value } } = event;
        setSelectedSidoList(
            typeof value === 'string' ? value.split(',') : value
        );
        if(value.length === 1){
            getSigunguList(value[0]);
        }else{
            setSigunguList([]);
            setSelectedSigunguList([]);
        }

        let list = sidoList;
        list.map((item) => {
            const find = value.find(e => item.sido === e);
            if(find){
                item.active = true;
            }else{
                item.active = false;
            }
        })
    };

    const sigunguMultiChange = (event) => {
         const { target: { value } } = event;
         setSelectedSigunguList(
            typeof value === 'string' ? value.split(',') : value
         );

        let list = sigunguList;
        list.map((item) => {
            const find = value.find(e => item.sigungu === e);
            if(find){
                item.active = true;
            }else{
                item.active = false;
            }
        })
    }

    //장애유형 변경 이벤트
    const oosTypeMultiChange = (event) => {
        const { target: { value } } = event;
        setSelectedOosTpCdList(
            typeof value === 'string' ? value.split(',') : value
        );
    }

    //에너지원 변경 이벤트
    const nrnMultiChange = (event) => {
        const { target: { value } } = event;
        setSelectedNrnCdList(
            typeof value === 'string' ? value.split(',') : value
        );
    }

    useEffect(() => {
        getPjtCodeList();
        getEnrgCodeList();
        getSiteCodeList();
        //장애유형 목록 조회
        getOosTypeCdList();
        //출장예정자,조치자 목록 조회
        getBtrList();
        //조치결과 목록 조회
        getActnRsltList();
        //구군 목록 조회
        getSigunguList(null);
    }, []);


    //프로젝트 변경 이벤트
    const pjtSeqChanged = (option) => {
        getSiteCodeList();
    }

    //프로젝트 목록 조회
    const getPjtCodeList = () => {
        axiosInstance.get('/pjtCodeList').then((Response)=>{
            if (Response.request.status === 200) {
                Response.data.list.unshift({dtlCd: "", dtlCdNm: "전체"});
                setPjtList(Response.data.list);
            }
        });
    }

    // 구군 목록 조회
    const getSigunguList = (sido) => {
        if(!sido) return;
        axiosInstance.get('/sigunguList', {params: {sido: sido}}).then((Response) => {
            if(Response.request.status === 200) {
                const list = Response.data.list;
                if(!list) return;

                list.map(item => item.active = false);
                setSigunguList(list);
            }
        })
    }

    //사이트 검색 목록 생성
    const getSiteCodeList = () => {
        axiosInstance.get('/siteCodeList', {params: {pjtSeq:getValues().pjtSeq}}).then((Response)=>{
            if (Response.request.status === 200) {
                const list  = [{dtlCd: "", dtlCdNm: "전체"}, ...Response.data.list];
                setSiteList(list);

                //site 검색 선택 정보 초기화
                setValue("siteSeq", "");
            }
        });
    }

    //에너지원 목록 조회
    const getEnrgCodeList = () => {
        axiosInstance.get('/codeList', {params: {grpCd: "NRN_GENT_CD"}}).then((Response)=>{
            if (Response.request.status === 200) {
                setEnrgList(Response.data.list);
            }
        });
    }

    //장애유형 목록 조회
    const getOosTypeCdList = () => {
        axiosInstance.get('/codeList', {params: {grpCd: "OOS_TYPE_CD"}}).then((Response)=>{
            if (Response.request.status === 200) {
                setOosTypeCdList(Response.data.list);
            }
        });
    }

    //출장예정자,조치자 목록 조회
    const getBtrList = () => {
        axiosInstance.get('/getBtrList').then((Response)=>{
            if (Response.request.status === 200) {
                setUsrBtrList(Response.data.list);
            }
        });
    }

    //조치결과 목록 조회
    const getActnRsltList = () => {
        axiosInstance.get('/codeList', {params: {grpCd: "ACTION_RSLT_CD"}}).then((Response)=>{
            if (Response.request.status === 200) {
                setActnRsltList(Response.data.list);
            }
        });
    }

    //시도별 장애확인 콜백함수
    const diagramChange = (diagramForm) => {

        var sidoArr = diagramForm.sido;
        if(diagramForm.sido.length > 1){
            setSigunguList([]);
        }
        var sigunguArr = diagramForm.sigungu;
        var oosArr = selectedOosTpCdList;
        var nrnArr = diagramForm.nrnGentCd;

        var sido = sidoArr.length ? `('${sidoArr.join("', '")}')` : "";
        var sigungu = sigunguArr.length ? `('${sigunguArr.join("', '")}')` : "";
        var oosTypeCd = oosArr.length ? `('${oosArr.join("', '")}')` : "";
        var nrnGentCd = nrnArr.length ? `('${nrnArr.join("', '")}')` : "";

        setValue("sido", sido);
        setValue("sigungu", sigungu);
        setValue("nrnGentCd", nrnGentCd);
        setValue("oosTypeCd", oosTypeCd);

        search(getValues());
    }

    const dataLoad = (data) => {
        var sidoArr = selectedSidoList;
        var sigunguArr = selectedSigunguList;
        var oosArr = selectedOosTpCdList;
        var nrnArr = selectedNrnCdList;

        var sido = sidoArr.length ? `('${sidoArr.join("', '")}')` : "";
        var sigungu = sigunguArr.length ? `('${sigunguArr.join("', '")}')` : "";
        var oosTypeCd = oosArr.length ? `('${oosArr.join("', '")}')` : "";
        var nrnGentCd = nrnArr.length ? `('${nrnArr.join("', '")}')` : "";

        setValue("sido", sido);
        setValue("sigungu", sigungu);
        setValue("oosTypeCd", oosTypeCd);
        setValue("nrnGentCd", nrnGentCd);

        search(getValues());
    }

    //조치등록&출장등록  버튼구분
    const buttonHandler = (type) => {
        if(!type) return;
        setBtnType(type);
        multiHandler();
    }

    //다중선택&단일선택 구분하여 폼 오픈
    const multiHandler = () => {
        if(checkList.length === 0){
            alertRef.current.handleOpen("확인", "조치등록/출장등록시 장애 목록에서 등록하고자 하는 장애건을 체크 해주세요.");
        }else if(checkList.length === 1){
            setOpen(true);
        }else if(checkList.length > 1){
            setMultiOpen(true);
        }
    }


    return (
        <Grid container
              alignItems="center"
              xs={12} sm={12} md={12} lg={12} xl={12}
              className="page-filter"
              sx={{p: 0}}
        >
            {/*프로젝트명*/}
            <Grid xs={12} sm={12} md={6} lg={4} xl={4} sx={{p: 2}}>
                <CustomAutocomplete name="pjtSeq"
                                    label="프로젝트"
                                    options={pjtList}
                                    value="dtlCd"
                                    text="dtlCdNm"
                                    control={control}
                                    getValues={getValues}
                                    errors={errors.pjtSeq}
                                    onChange={pjtSeqChanged}
                />
            </Grid>
            {/* 사이트 */}
            <Grid xs={12} sm={12} md={6} lg={4} xl={4} sx={{p: 2}}>
                <CustomAutocomplete name="siteSeq"
                                    label="사이트"
                                    options={siteList}
                                    value="dtlCd"
                                    text="dtlCdNm"
                                    control={control}
                                    getValues={getValues}
                                    errors={errors.siteSeq}
                />
            </Grid>

            {/* 시도 멀티셀렉트 */}
            <Grid xs={12} sm={12} md={6} lg={2} xl={2} sx={{p: 2}}>
                <FormControl sx={{m: 1, width: '100%'}}>
                    <InputLabel id="demo-multiple-name-label">시도</InputLabel>
                    <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        multiple
                        value={selectedSidoList}
                        onChange={sidoMultiChange}
                        input={<OutlinedInput label="Name"/>}
                        MenuProps={MenuProps}
                    >
                        {sidoList.map((item, index) => (
                            <MenuItem
                                key={index}
                                value={item.sido}
                                style={getStyles(item.sido, selectedSidoList, theme)}
                            >
                                {item.sido}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            {/* 구군 */}
            <Grid xs={12} sm={12} md={6} lg={2} xl={2} sx={{p: 2}}>
                <FormControl sx={{m: 1, width: '100%'}}>
                    <InputLabel id="demo-multiple-name-label">구군</InputLabel>
                    <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        multiple
                        value={selectedSigunguList}
                        onChange={sigunguMultiChange}
                        input={<OutlinedInput label="Name"/>}
                        MenuProps={MenuProps}
                    >
                        {sigunguList.map((item, index) => (
                            <MenuItem
                                key={index}
                                value={item.sigungu}
                                style={getStyles(item.sigungu, selectedSigunguList, theme)}
                            >
                                {item.sigungu}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            {/*에너지원*/}
            <Grid xs={12} sm={12} md={6} lg={2} xl={2} sx={{p: 2}}>
                {/*
                <CustomAutocomplete name="nrnGentCd"
                                    label="에너지원"
                                    options={enrgList}
                                    value="dtlCd"
                                    text="dtlCdNm"
                                    control={control}
                                    getValues={getValues}
                                    errors={errors.nrnGentCd}
                />
                */}
                <FormControl sx={{m: 1, width: '100%'}}>
                    <InputLabel id="demo-multiple-name-label">에너지원</InputLabel>
                    <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        multiple
                        value={selectedNrnCdList}
                        onChange={nrnMultiChange}
                        input={<OutlinedInput label="Name"/>}
                        MenuProps={MenuProps}
                    >
                        {enrgList.map((item, index) => (
                            <MenuItem
                                key={index}
                                value={item.dtlCd}
                                style={getStyles(item.dtlCdNm, selectedNrnCdList, theme)}
                            >
                                {item.dtlCdNm}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            {/*장애유형*/}
            <Grid xs={12} sm={12} md={6} lg={2} xl={2} sx={{p: 2}}>
                <FormControl sx={{m: 1, width: '100%'}}>
                    <InputLabel id="demo-multiple-name-label">장애유형</InputLabel>
                    <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        multiple
                        value={selectedOosTpCdList}
                        onChange={oosTypeMultiChange}
                        input={<OutlinedInput label="Name"/>}
                        MenuProps={MenuProps}
                    >
                        {oosTypeCdList.map((item, index) => (
                            <MenuItem
                                key={index}
                                value={item.dtlCd}
                                style={getStyles(item.dtlCdNm, selectedOosTpCdList, theme)}
                            >
                                {item.dtlCdNm}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            {/* 조회 버튼*/}
            <Grid xs={12} sm={12} md={6} lg={2} xl={1.5} sx={{p: 2}}>
                <Button variant="contained"
                        size="large"
                        color="primary"
                        sx={{p: 2, height: '52px', width: 1}}
                        startIcon={<SearchIcon/>}
                        onClick={handleSubmit(dataLoad)}
                >조회
                </Button>
            </Grid>

            {/*시도 별 장애확인 버튼*/}
            <Grid xs={12} sm={12} md={6} lg={2} xl={2.5} sx={{p: 2}}>
                <IncidentDiagramsBtn
                    name="diagram"
                    diagramChange={diagramChange}
                    sidoList={sidoList}
                    setSidoList={setSidoList}
                    sigunguList={sigunguList}
                    setSigunguList={setSigunguList}
                    selectedSidoList={selectedSidoList}
                    selectedSigunguList={selectedSigunguList}
                    setSelectedSidoList={setSelectedSidoList}
                    setSelectedSigunguList={setSelectedSigunguList}
                    selectedNrnCdList={selectedNrnCdList}
                    setSelectedNrnCdList={setSelectedNrnCdList}
                />
            </Grid>

            <Grid xs={12} sm={12} md={3} lg={2} xl={1} sx={{p: 2}}>
                <Button variant="contained"
                        size="large"
                        color="primary"
                        sx={{p: 1, height: '52px', width: 1}}
                        startIcon={<HomeRepairServiceIcon/>}
                        onClick={() => buttonHandler('btr')}
                >출장 등록</Button>
            </Grid>

            <Grid xs={12} sm={12} md={3} lg={2} xl={1} sx={{p: 2}}>
                <Button variant="contained"
                        size="large"
                        color="primary"
                        sx={{p: 1, height: '52px', width: 1}}
                        startIcon={<ConstructionIcon/>}
                        onClick={() => buttonHandler('actn')}
                >조치 등록</Button>
            </Grid>

            <IncidentDtlModal open={open}
                              setOpen={setOpen}
                              btnType={btnType}
                              checkList={checkList}
                              usrBtrList={usrBtrList}
                              actnRsltList={actnRsltList}
                              oosTypeCdList={oosTypeCdList}/>
            <IncidentMultiModal open={multiOpen}
                                setOpen={setMultiOpen}
                                checkList={checkList}
                                btnType={btnType}
                                usrBtrList={usrBtrList}
                                actnRsltList={actnRsltList}
                                oosTypeCdList={oosTypeCdList}/>
            <Alert ref={alertRef}/>
        </Grid>
    );
}

export default IncidentStsSearch;